var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'has-error': _vm.errorMessages.length > 0 }},[_c('editor',_vm._g({ref:"editor",attrs:{"disabled":_vm.disabled,"value":_vm.value,"model-events":"change keydown blur focus paste input","api-key":"q20nemaanvbywzuwgisyaugqa8gd8e05n9zmfeffi0o8wo5z","init":{
      placeholder: _vm.placeholder,
      branding: false,
      menubar: false,
      plugins: 'lists link image autoresize code paste media',
      image_list: _vm.route('tiny-mce.images.index').toString(),
      paste_as_text: false,
      min_height: 300,
      skin: 'webcomet',
      content_css: 'webcomet',
      //entity_encoding : 'raw',
      //force_br_newlines: false,
      //force_p_newlines: false,
      //forced_root_block: '',
      images_upload_url: _vm.route('upload-image.store'),
      images_upload_handler: _vm.imageUploadHandler,
      media_url_resolver: _vm.mediaUrlResolver,
      relative_urls: false,
      convert_urls: false,
      toolbar: 'styleselect | fontsizeselect | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist | link | image | media | code',
      toolbar_sticky: true,
      toolbar_sticky_offset: 64,
      media_live_embeds: true,
      language: _vm.getLanguage(),

    }},on:{"input":_vm.handleInput}},_vm.$listeners)),_vm._v(" "),_c('div',{staticClass:"pl-3 mt-2"},[_c('VMessages',{attrs:{"value":_vm.internalErrorMessages,"color":"error"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }